import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsletterService } from '../../../services/newsletter.service';

@Component({
  selector: 'app-newsletter-detail',
  templateUrl: './newsletter-detail.component.html',
  styleUrls: ['./newsletter-detail.component.scss']
})
export class NewsletterDetailComponent implements OnInit, OnDestroy {

  campaignId!: number;
  campaign: any = null;
  metrics: any = null;
  recipients: any[] = [];

  page: number = 0;
  size: number = 20;
  totalPages: number = 0;
  totalElements: number = 0;

  loading: boolean = false;
  errorMessage: string = '';

  private refreshInterval: any = null;

  constructor(
    private newsletterService: NewsletterService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.campaignId = Number(this.route.snapshot.paramMap.get('id'));
    this.load();
  }

  ngOnDestroy(): void {
    this.stopAutoRefresh();
  }

  load(): void {
    this.loading = true;
    this.newsletterService.getCampaign(this.campaignId).subscribe({
      next: (c) => {
        this.campaign = c;
        this.loadMetrics();
        this.loadRecipients();
        this.loading = false;

        // Si está enviando, auto-refresh
        if (c.status === 'SENDING') {
          this.startAutoRefresh();
        } else {
          this.stopAutoRefresh();
        }
      },
      error: () => {
        this.errorMessage = 'No se pudo cargar la campaña.';
        this.loading = false;
      }
    });
  }

  loadMetrics(): void {
    this.newsletterService.getMetrics(this.campaignId).subscribe({
      next: (m) => this.metrics = m,
      error: () => {}
    });
  }

  loadRecipients(): void {
    this.newsletterService.getRecipients(this.campaignId, this.page, this.size).subscribe({
      next: (r) => {
        this.recipients = r.content || [];
        this.totalElements = r.totalElements || 0;
        this.totalPages = r.totalPages || 0;
      },
      error: () => this.recipients = []
    });
  }

  prevPage(): void {
    if (this.page > 0) {
      this.page--;
      this.loadRecipients();
    }
  }

  nextPage(): void {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.loadRecipients();
    }
  }

  startAutoRefresh(): void {
    if (this.refreshInterval) return;
    this.refreshInterval = setInterval(() => {
      this.loadMetrics();
      this.newsletterService.getCampaign(this.campaignId).subscribe({
        next: (c) => {
          this.campaign = c;
          if (c.status !== 'SENDING') {
            this.stopAutoRefresh();
            this.loadRecipients();
          }
        }
      });
    }, 5000);
  }

  stopAutoRefresh(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  cancelCampaign(): void {
    if (!confirm('¿Cancelar esta campaña programada?')) return;
    this.newsletterService.cancelCampaign(this.campaignId).subscribe({
      next: () => this.load(),
      error: (err) => alert('Error: ' + (err.error || 'No se pudo cancelar'))
    });
  }

  goToEdit(): void {
    this.router.navigate(['/newsletter', this.campaignId, 'edit']);
  }

  goBack(): void {
    this.router.navigate(['/newsletter']);
  }

  statusLabel(status: string): string {
    const labels: any = {
      'DRAFT': 'Borrador',
      'SCHEDULED': 'Programada',
      'SENDING': 'Enviando',
      'SENT': 'Enviada',
      'FAILED': 'Fallida',
      'CANCELLED': 'Cancelada'
    };
    return labels[status] || status;
  }

  statusClass(status: string): string {
    const classes: any = {
      'DRAFT': 'badge-draft',
      'SCHEDULED': 'badge-scheduled',
      'SENDING': 'badge-sending',
      'SENT': 'badge-sent',
      'FAILED': 'badge-failed',
      'CANCELLED': 'badge-cancelled'
    };
    return classes[status] || '';
  }

  recipientStatusLabel(status: string): string {
    const labels: any = {
      'PENDING': 'Pendiente',
      'SENT': 'Enviado',
      'FAILED': 'Fallido'
    };
    return labels[status] || status;
  }

  recipientStatusClass(status: string): string {
    const classes: any = {
      'PENDING': 'rec-pending',
      'SENT': 'rec-sent',
      'FAILED': 'rec-failed'
    };
    return classes[status] || '';
  }
}





